import { StatementType } from './statement-types';

export const ChineseStatements: Record<StatementType, string[]> = {
  annoyed: [
    '难道我昨天没告诉你吗？',
    '别以为我没有在注意！',
    '这么吵我根本没法思考！',
    '你这是被动攻击吗？',
    '你知道那个不该放在那里！',
    '自从你借走我的割草机已经过了7小时15天了！',
    '你非得嚼得这么响吗？',
    '快拿走吧！',
    '如果你没有好话，就什么都别说！',
    '我们赶紧走吧。',
  ],
  frustrated: [
    '好吧那就随你吧！',
    '我永远也搞不懂！',
    '网站打不开！',
    '这个罐头打不开！',
    '你不能那样打开！',
    '你总要说最后一句！',
  ],
  angry: [
    '你到底在干什么！？',
    '阴沉毒蛇的私生子！',
    '我要杀了你！',
    '不，你错了！',
    '你本该保护我们！',
  ],
  random: [
    '鹅群来了！鹅群来了！',
    '红薯既不甜也不是土豆。',
    '好吧那就这样！Yalla！',
    '奇迹难道永远不会停止吗？',
    '“哇，那可是好多蓝莓啊！”',
    '天哪！',
    '你确定要那样做吗？',
    '主啊，怜悯！',
    '今天的天空好蓝。',
    '我才不怕什么鬼！',
    '我猜你不会做饭？',
    '大家冷静深呼吸。',
    '爱就是答案。',
  ],
  child: [
    '哈哈！',
    '不够快！',
    '哇哦！',
    '老了！',
    '哈哈哈哈',
    '咻——',
    '想放弃了吗？',
    '看我的！',
    '累了吗？',
    '借过！',
    '小心！',
  ],
  'child-no': ['不行！'],
  'stay-near-me': ['待在我身边，不要乱跑。'],
};
